import { Link, useNavigate } from "react-router-dom";
import "./LoggedOutProfileGate.css";

export const LOGGED_OUT_SIGNIN_PATH = "/welcome?auth=signin";

export function goToLoggedOutSignIn(navigate) {
  if (typeof navigate === "function") {
    navigate(LOGGED_OUT_SIGNIN_PATH);
    return;
  }
  window.location.assign(LOGGED_OUT_SIGNIN_PATH);
}

/** Click/keyboard handlers that send logged-out visitors to sign-in. */
export function loggedOutSignInProps(isLoggedOut, navigate) {
  if (!isLoggedOut) return {};
  const go = (e) => {
    e?.preventDefault?.();
    goToLoggedOutSignIn(navigate);
  };
  return {
    role: "link",
    tabIndex: 0,
    onClick: go,
    onKeyDown: (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        go(e);
      }
    },
  };
}

export default function LoggedOutProfileGate({
  name,
  noun = "drops",
}) {
  const label = name || "this creator";
  return (
    <div className="lop-card">
      <h2 className="lop-title">
        Sign in to see {label}&apos;s {noun}
      </h2>
      <Link to={LOGGED_OUT_SIGNIN_PATH} className="lop-cta">
        Sign In / Join Free
      </Link>
      <p className="lop-note">No credit card needed to join</p>
    </div>
  );
}

export function LoggedOutLockedSection({ children, name, noun = "drops" }) {
  const navigate = useNavigate();

  return (
    <div className="lop-locked">
      <div className="lop-blur" aria-hidden="false">
        {children}
      </div>
      <div
        className="lop-overlay"
        role="presentation"
        onClick={() => goToLoggedOutSignIn(navigate)}
      >
        <div
          className="lop-card-wrap"
          onClick={(e) => e.stopPropagation()}
        >
          <LoggedOutProfileGate name={name} noun={noun} />
        </div>
      </div>
    </div>
  );
}

export function MaybeLoggedOutLockedSection({ locked, name, noun = "drops", children }) {
  if (!locked) return <>{children}</>;
  return (
    <LoggedOutLockedSection name={name} noun={noun}>
      {children}
    </LoggedOutLockedSection>
  );
}
